module.exports = "a {\n\tcursor: pointer;\n}\n\n.not-active {\n   pointer-events: none;\n}\n"